document.addEventListener('DOMContentLoaded', () => {
  // 本来のお問い合わせフォーム（id="ContactForm"）にのみ関与する。
  // form[action*="/contact"] で広く掴むと、Shopifyのスパム防止(hCaptcha)
  // チャレンジページの再送信フォームまで掴んでしまい送信を殺すため、id で絞る。
  const form = document.querySelector('#ContactForm');
  if (!form) return;

  // 「お問い合わせ内容（複数選択可）」
  // Shopifyのcontactフォームは配列フィールド(name="...[]")を「無効です」で拒否する。
  // そのためチェックボックスは表示専用(name無し / .js-inquiry-option)にし、
  // 選択値をカンマ区切りで単一の hidden フィールド contact[お問い合わせ内容] に格納して送る。
  const options = form.querySelectorAll('.js-inquiry-option');
  if (options.length === 0) return; // お問い合わせフォーム以外（チャレンジページ等）には関与しない

  const hidden = form.querySelector('input[name="contact[お問い合わせ内容]"]');
  const error = form.querySelector('.checkbox-error');

  // チェック状態を hidden フィールドへ同期し、1つ以上選択されているか返す
  const syncSelection = () => {
    const selected = Array.from(options)
      .filter((option) => option.checked)
      .map((option) => option.value);

    if (hidden) {
      hidden.value = selected.join('、');
    }

    return selected.length > 0;
  };

  // 選択が変わるたびに hidden を更新（captcha再送信などでも常に最新値が入るように）
  options.forEach((option) => option.addEventListener('change', syncSelection));
  syncSelection();

  form.addEventListener(
    'submit',
    (e) => {
      const hasSelection = syncSelection();

      if (!hasSelection) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (error) {
          error.style.display = 'block';
        }

        return false;
      }

      if (error) {
        error.style.display = 'none';
      }
    },
    true
  );
});
